import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Router, RouterModule } from '@angular/router';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { QRCodeModule } from 'angularx-qrcode';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss'],
  standalone: true,
  imports: [AngularSvgIconModule, NgOptimizedImage, CommonModule, QRCodeModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadComponent {
  public link: string;
  public desktop = new BehaviorSubject(true);

  private destroyed = new Subject<void>();

  constructor(private responsive: BreakpointObserver, private router: Router) {}

  ngOnInit() {
    this.link = this.generateRedirectLink();

    this.responsive.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
    ])
    .pipe(
      takeUntil(this.destroyed)
    )
    .subscribe(result => {
      if (result.matches) {
        this.desktop.next(false);
      } else {
        this.desktop.next(true);
      }
    });
  }

  private generateRedirectLink(): string {
    const relativePath = this.router.createUrlTree(['/download']).toString();
    return 'https://hostelhop.io' + relativePath;
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}



// generate a token
// claims
// user id
// user name
// user


// login
// backend gets credentials
// backend validates credentials
// backend generates token that has enough information to identify the user
// jwt
// encodes
